module.exports = __webpack_public_path__ + "media/images/remote-learning-block-01-ca6d9c1ee5f6cf14a20c0289b6018e0fa549a49e1cdd0defaac27bb8855d935f.svg";